import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import styles from './DrawerSkeleton.module.scss'

const DrawerSkeleton = ({
  width = '100%',
  height = 16,
  borderRadius = 4,
  className = ''
}) => {
  return (
    <Box
      className={`${styles.skeleton} ${className}`}
      style={{ width, height, borderRadius }}
    />
  )
}

DrawerSkeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
}

export default DrawerSkeleton
